import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "centered w100",
  style: {"padding-top":"10px"}
}
const _hoisted_2 = {
  class: "mc",
  style: {"width":"450px"}
}
const _hoisted_3 = {
  key: 0,
  class: "with_white_bg",
  style: {"padding":"30px 0px"}
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "fs13 fw400 text-left" }
const _hoisted_6 = {
  class: "fs18 fw600 text-left",
  style: {"color":"#222222","padding-bottom":"13px","line-height":"1.6"}
}
const _hoisted_7 = {
  key: 0,
  style: {"margin":"0","border-style":"solid none none none","border-top-width":"1px","border-top-color":"#cccccc"}
}
const _hoisted_8 = {
  key: 0,
  class: "fs13"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = {
  key: 1,
  class: "fs13 text-left kaigyo pad10",
  style: {"color":"#333333"}
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = {
  key: 1,
  class: "w100 skyblueBg centered fw600 fs12",
  style: {"height":"5px","padding-top":"0px","letter-spacing":"0.3px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MailPreviewPartsHeader = _resolveComponent("MailPreviewPartsHeader")!
  const _component_MailPreviewPartsOnlineTable = _resolveComponent("MailPreviewPartsOnlineTable")!
  const _component_MailPreviewPartsPublicRoomTable = _resolveComponent("MailPreviewPartsPublicRoomTable")!
  const _component_MailPreviewPartsSelectableMags = _resolveComponent("MailPreviewPartsSelectableMags")!
  const _component_MailPreviewPartsBlueButton = _resolveComponent("MailPreviewPartsBlueButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MailPreviewPartsHeader),
      (_ctx.rcm.selectedMailFlow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.member)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.member.company_name), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.member.name) + " 様 ", 1),
                  (_ctx.Util.isPresent(_ctx.rcm.appo.memo))
                    ? (_openBlock(), _createElementBlock("hr", _hoisted_7))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              style: {"margin":"20px 0 0 0","box-shadow":"0 0","padding":"0px","border-radius":"0px"},
              class: "ScheduleMessageContent withEditable posRe",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addMessage && _ctx.addMessage(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentArr, (content, contentindex) => {
                return (_openBlock(), _createElementBlock("div", { key: contentindex }, [
                  (_ctx.blockVals.includes(content))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (content == `<<オンライン会議ブロック>>`)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              (_ctx.Util.isOnline(_ctx.rcm.appo.location_name))
                                ? (_openBlock(), _createBlock(_component_MailPreviewPartsOnlineTable, { key: 0 }))
                                : _createCommentVNode("", true)
                            ]))
                          : (content == `<<調整ページブロック>>`)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createVNode(_component_MailPreviewPartsPublicRoomTable, {
                                  showFixedAppo: true,
                                  showAnswerResults: false
                                })
                              ]))
                            : (content == `<<出席者ブロック>>`)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, " "))
                              : (content == `<<担当者ブロック>>`)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createVNode(_component_MailPreviewPartsSelectableMags, { isFix: true })
                                  ]))
                                : (content == `<<メモブロック>>` && _ctx.rcm.appo.memo)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                      _createTextVNode(" 【メモ】"),
                                      _hoisted_14,
                                      _createTextVNode(" " + _toDisplayString(_ctx.rcm.appo.memo), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                        _hoisted_15
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("span", { innerHTML: content }, null, 8, _hoisted_17),
                        _hoisted_18
                      ])),
                  _hoisted_19
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.Util.isPresent(_ctx.rcm.selectedMailFlow.content))
        ? (_openBlock(), _createElementBlock("div", _hoisted_20))
        : _createCommentVNode("", true),
      _createVNode(_component_MailPreviewPartsBlueButton, {
        buttonName: _ctx.rcm.selectedMailFlow.button_name
      }, null, 8, ["buttonName"]),
      (_ctx.rcm.selectedMailFlow.display_parent_room_link_button)
        ? (_openBlock(), _createBlock(_component_MailPreviewPartsBlueButton, {
            key: 2,
            buttonName: `調整ページへ`
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}